var _defineProperty = require("/home/emil/thebiz/frontend/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var url = require('url');

function bitcoin(_ref) {
  var address = _ref.address,
      amount = _ref.amount,
      label = _ref.label,
      message = _ref.message,
      lightning = _ref.lightning;
  var uri = {
    protocol: 'bitcoin',
    hostname: address,
    pathname: '',
    query: {}
  };
  if (amount != null) uri.query.amount = amount;
  if (label != null) uri.query.label = label;
  if (message != null) uri.query.message = message;
  if (lightning != null) uri.query.lightning = lightning;
  return url.format(uri);
}

function lightning(_ref2) {
  var lnurl = _ref2.lnurl;
  var uri = {
    protocol: 'lightning',
    hostname: lnurl,
    pathname: '',
    query: {}
  };
  return url.format(uri);
}

function ethereum(_ref3) {
  var address = _ref3.address,
      _ref3$functionName = _ref3.functionName,
      functionName = _ref3$functionName === void 0 ? '' : _ref3$functionName,
      _ref3$args = _ref3.args,
      args = _ref3$args === void 0 ? {} : _ref3$args,
      amount = _ref3.amount,
      gas = _ref3.gas,
      gasLimit = _ref3.gasLimit,
      gasPrice = _ref3.gasPrice,
      chainId = _ref3.chainId;
  var uri = {
    protocol: 'ethereum',
    username: chainId,
    hostname: address,
    pathname: functionName,
    query: _objectSpread({}, args)
  };
  if (amount != null) uri.query.value = amount.toExponential();
  if (gas != null) uri.query.gas = gas;
  if (gasLimit != null) uri.query.gasLimit = gasLimit;
  if (gasPrice != null) uri.query.gasPrice = gasPrice;
  return url.format(uri);
}

module.exports = {
  bitcoin: bitcoin,
  ethereum: ethereum,
  lightning: lightning
};